<template>
  <div>
    <div v-if="isReady">
      <!-- Cartes (même présentation que la liste des boutiques) -->
      <div class="row g-6 g-xl-9" v-if="getFilteredStores && getFilteredStores.length">
        <div class="col-md-6 col-xl-4" v-for="item in getFilteredStores" :key="item.id">
          <router-link :to="{ name: 'store-details', params: { id: item.id } }" class="store-card text-decoration-none">
            <div class="store-card-side-bar" :class="item.etat === 'active' ? 'bar-active' : 'bar-archived'"></div>
            <div class="store-card-content">
              <div class="store-card-initial" :class="item.etat === 'active' ? 'initial-active' : 'initial-archived'">
                {{ item.name?.charAt(0)?.toUpperCase() || '?' }}
              </div>
              <div class="store-card-info-block">
                <div class="store-card-name">{{ item.name }}</div>
                <div class="store-card-meta"><i class="bi bi-telephone me-1"></i>{{ item.phone || '—' }}</div>
                <div class="store-card-meta"><i class="bi bi-geo-alt me-1"></i>{{ item.address || '—' }}</div>
                <div class="store-card-meta"><i class="bi bi-box-seam me-1"></i>{{ item.count || 0 }} {{ $t('store.menu.product').toLowerCase() }}</div>
              </div>
              <div class="store-card-badge" :class="item.etat === 'active' ? 'badge-active' : 'badge-archived'">
                <i :class="item.etat === 'active' ? 'bi bi-check-circle-fill' : 'bi bi-lock-fill'"></i>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- Aucun entrepôt -->
      <div class="card" v-else>
        <div class="card-body text-center py-15">
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('store.message') }}</h2>
          <p class="text-gray-400 fs-4 fw-bold py-7">{{ $t('button.clic') }}</p>
          <button v-if="$can('magasin_create')" class="createStore btn btn-primary btn-sm">{{ $t('store.new_store') }}</button>
          <div class="pt-8">
            <img src="/assets/media/illustrations/sketchy-1/illustration1-custom.svg?v=2" alt="" class="mw-100 h-150px h-sm-225px" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-10"><Loader /></div>

      <div class="modal fade" tabindex="-1" id="createModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('store.create.title') }}</h5>
              <!--begin::Close-->
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                      fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                      fill="currentColor" />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>

              <!--end::Close-->
            </div>
            <div class="modal-body">
              <!--begin:Form-->
              <form @submit.prevent="formSubmit" id="kt_modal_new_target_form" class="form">

                <div class="d-flex flex-column mb-8 fv-row">
                  <!--begin::Label-->
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.name') }}</span>
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                      title="Specify a target name for future usage and reference"></i>
                  </label>
                  <!--end::Label-->
                  <input type="text" class="form-control form-control-solid" v-model="formStore.name"
                    :placeholder="$t('store.form.name')" required />
                </div>

                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.address') }}</span>
                    <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                      title="Veuillez bien renseigner ce champ"></i>
                  </label>
                  <input type="text" class="form-control form-control-solid" v-model="formStore.address"
                    :placeholder="$t('store.form.address')" required />
                </div>

                <div class="d-flex flex-column mb-8 fv-row">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span class="required">{{ $t('store.form.telephone') }}</span>
                  </label>
                  <vue-tel-input 
                        @country-changed="thirstInputCountryChanged" 
                        :inputOptions="options"
                        @input="thirstInputChanged"
                        :dropdownOptions="dropdownOptions" 
                        :autoDefaultCountry="true" 
                        id="store_phone"
                        class="form-control form-control-solid" name="store_phone" 
                        v-model="phoneNumber">
                  </vue-tel-input>
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="d-flex flex-column mb-8 fv-row">
                      <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>{{ $t('store.form.prefixe') }}</span>
                      </label>
                      <input type="text"  class="form-control form-control-solid" v-model="formStore.prefixe"
                             :placeholder="$t('store.placeholder.prefixe')" />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="d-flex flex-column mb-8 fv-row">
                      <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>{{ $t('store.form.transfer_number') }}</span>
                      </label>
                      <input type="text"  class="form-control form-control-solid" v-model="formStore.transfer_number"
                             :placeholder="$t('store.placeholder.transfer_number')" />
                    </div>
                  </div>

                </div>
                <div class="col-12 my-1">
                  <label class="d-flex align-items-center fs-6 fw-bold">
                    <span class="">{{ $t('shop.status') }}</span>
                  </label>
                  <!--end::Label-->
                  <select class="form-select  kt_select2 form-control form-control-solid" name="active" v-model="formStore.etat"
                          data-control="select2" data-dropdown-parent="#createModal" data-search="true"
                          data-placeholder="Select an option">
                    <option></option>
                    <option value="active">{{ $t('shop.active') }}</option>
                    <option value="inactive">{{ $t('shop.inactive') }}</option>
                  </select>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{
                    $t('button.close')
                  }}</button>
                  <button type="submit" class="btn btn-sm  btn-primary" :disabled="isLoading">
                    <span class="indicator-label" v-if="!isLoading">{{ $t('button.save') }}</span>
                    <span class="" v-else>{{ $t('loading') }}
                      <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css';
import { mapActions, mapGetters } from 'vuex'
import Loader from "@/components/Loader.vue";
export default {
  components: {
    VueTelInput,
    Loader
  },
  data() {
    return {
      title: i18n.global.t('breadcrumbs.store.path'),
      isLoading: false,
      submitType: '',
      formStore: {
        id: '',
        name: '',
        address: '',
        phone: '',
        etat: 'active',
        prefixe: '',
        transfer_number: ''
      },
      breadcrumbs: [
        {
          name: i18n.global.t('breadcrumbs.store.dashboard'),
          path: '/admin/dashboard'
        },
        {
          name: i18n.global.t('breadcrumbs.store.pathList'),
          path: '/store'
        }
      ],
      phoneNumber:'',
      dialCode:'',
      search: null,
      isReady: false,
      status: "all",
      filterBy: [
        {name: 'All', value: "all", translate: 'store.all_shops'},
        {name: 'Inactive', value: "desactive", translate: 'shop.inactive'},
        {name: 'Active', value: "active", translate: 'shop.active'}
      ]
    }
  },
  // Filtre / recherche : dans la barre du haut (StoresLayout)
  inject: {storeListState: {default: null}},
  watch: {
    'storeListState.search'(value) {
      this.search = value
    },
    'storeListState.status'(value) {
      this.isReady = false
      this.status = value
      this.loadStore({status: this.status, search: this.search}).then(() => {
        this.isReady = true
      })
    },
    search() {
      this.isReady = false
      this.loadStore({status: this.status, search: this.search}).then(() => {
        this.isReady = true
      })
    }
  },
  computed: {
    ...mapGetters('store', ['getStores']),

    formSubmit: function () {
      return (this.submitType == "create") ? this.submitCreate : this.submitUpdate
    },

    getFilteredStores() {
      if (this.search) {
        return this.getStores.filter(store => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every(x => store.name.toLowerCase().includes(x))
        })
      }
      return this.getStores
    },

    options(){
      return {
        placeholder: i18n.global.t('enter_phone'),
        showDialCode : false
      }
    },
    dropdownOptions(){
      return {
        showDialCodeInSelection: true,
        showDialCodeInList: true,
        showFlags: true
      }
    }
  },
  mounted() {
    this.isReady = false
    this.loadStore({status: this.status, search: this.search}).then(() => {
      this.isReady = true
    })

    $(document).on("click", ".createStore", (e) => {
      this.submitType = "create";
      $('#createModal').modal('toggle')
    });
    $("body .kt_select2").select2()

    $('.kt_select').change((e) => {
      switch (e.target.name) {
        case 'filter':
          this.isReady = false
          this.status = e.target.value
          this.loadStore({status: this.status, search: this.search}).then(() => {
            this.isReady = true
          })
          break;
        case 'active':
          this.formStore.active = !!e.target.value
          break;
        default:
          break;
      }
    });
  },
  methods: {
    ...mapActions('store', ['loadStore', 'createStore', 'updateStore']),

    async submitCreate() {
      let response = {};
      this.isLoading = true;
      this.formStore.phone = this.phoneNumber? this.dialCode +' '+ this.phoneNumber : ''
      try {
        response = await this.createStore(this.formStore);
        $('#createModal').modal('toggle')
        window.toastr['success'](i18n.global.t('notification.store.created'))
        this.$router.push('/admin/stores/' + response.data.store.id + '/views')
        this.isLoading = false;
        this.formStore.name = "";
        this.formStore.address = "";
        this.formStore.phone = "";
        this.formStore.prefixe = "";
        this.formStore.etat = "";
        this.formStore.transfer_number = "";
      } catch (err) {
        this.isLoading = false;
      }
    },

    async submitUpdate() {
      let response = {}
      this.isLoading = true;
      try {
        response = await this.updateStore(this.formStore);
        window.toastr['success'](i18n.global.t('notification.store.updated'))
        $('#createModal').modal('toggle')
        this.isLoading = false;
        this.formStore.name = "";
        this.formStore.address = "";
        this.formStore.phone = "";
        this.formStore.prefixe = "";
        this.formStore.etat = "";
        this.formStore.transfer_number = "";
      } catch (err) {
        window.toastr['error'](err)
        this.isLoading = false;
      }
    },

    async deletedStore() {
      try {
        await this.deleteStore(this.formStore.id);
        window.toastr['success'](i18n.global.t('notification.store.deleted'))
      } catch (err) {
        window.toastr['error'](err)
      }
    },

    startModalUpdate(data) {
      this.submitType = "update";
      this.formStore.id = data.id;
      this.formStore.name = data.name;
      this.formStore.address = data.address;
      this.formStore.phone = data.phone;
      this.formStore.prefixe = data.prefixe;
      this.formStore.transfer_number = data.transfer_number;
      $('#createModal').modal('toggle')
    },

    startAlert(data) {
      this.formStore.id = data.id;
      this.formStore.name = data.name;
      this.formStore.address = data.address;
      this.formStore.phone = data.phone;
      this.formStore.prefixe = data.prefixe;
      this.formStore.transfer_number = data.transfer_number;
      Swal.fire({
        text: i18n.global.t('swal.store.text') + " (" + this.formStore.name + ").",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.deleted'),
        cancelButtonText: 'Annuler',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedStore()
        }
      })
    },

    thirstInputCountryChanged(country) {
      this.dialCode = '+' + country.dialCode
    },

    thirstInputChanged(number, phoneObject) {
      let errorDiv = document.querySelector('[data-field="store_phone"][data-field="store_phone"][data-validator="callback"]')
      if (errorDiv) {
        errorDiv.remove()
      }

      if (phoneObject) {
        //this.formStore.phone = phoneObject.nationalNumber
        this.formStore.phone = '+' + phoneObject.countryCallingCode
      }
    },
  },

}
</script>
<style scoped>
/* Cartes entrepôt : même présentation que les cartes boutique */
.store-card {
  display: flex;
  align-items: stretch;
  height: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
  margin-bottom: 4px;
}
.store-card:hover {
  box-shadow: 0 6px 20px rgba(0,0,0,0.12);
  transform: translateY(-2px);
}
.store-card-side-bar {
  width: 5px;
  flex-shrink: 0;
  border-radius: 12px 0 0 12px;
}
.bar-active   { background: var(--kt-primary); }
.bar-archived { background: #f1416c; }
.store-card-content {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 24px 20px;
  flex: 1;
  min-width: 0;
}
.store-card-initial {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -1px;
}
/* dégradé à la couleur de la boutique (personnalisation), couleur par défaut sinon */
.initial-active   { background: linear-gradient(135deg, var(--kt-primary-active, #a87840), var(--kt-primary, #0b3d87)); }
.initial-archived { background: linear-gradient(135deg, #a31010, #f1416c); }
.store-card-info-block {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.store-card-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e2130;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.store-card-meta {
  font-size: 0.85rem;
  color: #a1a5b7;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.store-card-badge {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  align-self: flex-start;
}
.store-card-badge.badge-active   { background: rgba(80,205,137,0.15); color: #50cd89; }
.store-card-badge.badge-archived { background: rgba(241,65,108,0.12); color: #f1416c; }
</style>